import React from 'react';

interface OfferHeaderProps {
  heading?: string;
  description?: string;
  imagePath?: string;
  title?: string;
}

const OfferHeader: React.FC<OfferHeaderProps> = ({
  heading,
  description,
  imagePath,
  title
}) => {
  return (
    <div className=" border-b">
      {imagePath && (
        <div className="mb-6 text-center">
          <img 
            src={imagePath} 
            alt={title || 'Offer'} 
            className="max-h-56 mx-auto object-contain rounded-lg shadow-sm" 
          />
        </div>
      )}
      
      {heading && (
        <h1 className="text-2xl md:text-3xl font-bold mb-3 text-black">
          {heading}
        </h1>
      )}
      
      {description ? (
        <p className="text-base md:text-lg text-theme-text mb-4 max-w-2xl whitespace-pre-line">
          {description}
        </p>
      ) : (
        <p className="text-base md:text-lg text-theme-text mb-4 max-w-2xl whitespace-pre-line">
          No description available.
        </p>
      )}
    </div>
  );
};

export default OfferHeader;
